import * as React from 'react';
import { observer } from 'mobx-react';
import { ErrorCode } from '../../domains/errorCode';
import { useTranslation } from 'react-i18next';
import './error-panel.scss';

export interface Props {
  code: ErrorCode | null;
}

export const ErrorPanel = observer(({ code }: Props) => {
  const { t } = useTranslation('', { keyPrefix: 'ERROR' });
  return <>{code && <div className="alert alert-error">{t(`${code}`)}</div>}</>;
});
